import type {MediaValidationResult} from 'utilities/validate-image';

import type {UploadStagedMediaMutationData} from './graphql/UploadStagedMediaMutation.graphql';

export enum Status {
  ValidationFailed,
  StagedUploadFailed,
  FinalUploadFailed,
  Success,
}

export interface StagedUploadResult {
  url: string;
  parameters: {
    name: string;
    value: string;
  }[];
  resourceUrl?: string | null;
}

export interface StagedUploadFileResult {
  stagedUploadResult: StagedUploadResult;
  media: File;
}

export interface ResultValidationError {
  media: File;
  status: Status.ValidationFailed;
  error: MediaValidationResult;
}

export interface ResultStagedUploadFailed {
  media: File;
  status: Status.StagedUploadFailed;
  message?: string;
}

export interface ResultFinalUploadFailed {
  media: File;
  status: Status.FinalUploadFailed;
}

export interface ResultSuccess {
  media: File;
  status: Status.Success;
  path: string;
}

export type Result =
  | ResultValidationError
  | ResultStagedUploadFailed
  | ResultFinalUploadFailed
  | ResultSuccess;

export interface MediasUploadResults {
  hasReturnedNull: boolean;
  urls: StagedUploadResult[];
  userErrors: UploadStagedMediaMutationData.StagedUploadsCreateUserErrors[];
}

export interface StageMediasResult {
  errors: ResultStagedUploadFailed[];
  stagedMedias: StagedUploadFileResult[];
}
